import { DynamicContentType } from '../../types/content.types.js'
import { LucideIconName } from '../../types/lucide.types.js'
import { HeaderTag } from '../../types/text.types.js'
import { TextAlignment } from '../../types/text.types.js'
import { FontWeight } from '../../types/text.types.js'
import { TextColor } from '../../types/text.types.js'

export type HeaderData = {
  text: string
  color: TextColor
  leading: 'default' | '105' | '110' | '120' | '130' | '140' | '150'
  fontSize:
    | '1rem'
    | '1.125rem'
    | '1.25rem'
    | '1.5rem'
    | '2rem'
    | '2.5rem'
    | '3rem'
    | '4rem'
  fontWeight: FontWeight
  alignment: TextAlignment
  marginBottom: string
  marginTop: string
  maxWidth?: string
  level?: HeaderTag
}

export const header: DynamicContentType<HeaderData> = {
  name: 'header',
  viewName: 'Rubrik',
  featureKey: 'header',
  icon: LucideIconName.CaseSensitive,
  default: true,
  uuid: '',
  data: {
    leading: 'default',
    text: 'Min rubrik',
    color: 'black',
    fontWeight: 'bold',
    fontSize: '2rem',
    alignment: 'left',
    marginBottom: '0',
    marginTop: '0',
  },
}
